import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

interface IDiscountMortgageLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>;
}

export const DiscountMortgageLabel: React.FC<IDiscountMortgageLabelProps> = ({ ref, ...props }) => {
  return (
    <div className={styles['label']} {...props} ref={ref}>
      <Label
        background="decorative-purple"
        color="theme-white"
        icon={<IconProductHighDemand16 color="icon-inverted-default" />}
      >
        Льготная ипотека
      </Label>
    </div>
  );
};
